// Central definition of all system roles
// Used by AdminUsersPage, AdminRolesPage, permissionService
export const ALL_ROLES = [
  // System Admin — full access to everything
  { value: 'Administrator',                         label: 'System Administrator',                  group: 'Admin',        permLevel: 'SystemAdmin'  },
  // Admin — limited admin panel + full user app
  { value: 'Admin',                                 label: 'Administrator (Limited)',                group: 'Admin',        permLevel: 'Admin'        },
  // Executive — full user app, no admin panel
  { value: 'CEO',                                   label: 'CEO',                                   group: 'Executive',    permLevel: 'Executive'    },
  { value: 'CPO',                                   label: 'CPO (Chief Product Officer)',            group: 'Executive',    permLevel: 'Executive'    },
  { value: 'Chief Operating Officer',               label: 'Chief Operating Officer',               group: 'Executive',    permLevel: 'Executive'    },
  { value: 'Co-Founder',                            label: 'Co-Founder',                            group: 'Executive',    permLevel: 'Executive'    },
  // Management
  { value: 'Manager',                               label: 'Project Manager',                       group: 'Management',   permLevel: 'Manager'      },
  { value: 'Head of Product Delivery',              label: 'Head of Product Delivery',              group: 'Management',   permLevel: 'Manager'      },
  // Specialists
  { value: 'Implementation and Training Specialist',label: 'Implementation & Training Specialist',  group: 'Specialists',  permLevel: 'Specialist'   },
  { value: 'Senior Implementation Specialist',      label: 'Senior Implementation Specialist',      group: 'Specialists',  permLevel: 'Specialist'   },
  { value: 'Communication Specialist',              label: 'Communication Specialist',              group: 'Specialists',  permLevel: 'Specialist'   },
  { value: 'Representative',                        label: 'Representative',                        group: 'Specialists',  permLevel: 'Specialist'   },
  { value: 'Senior Expert Risk and Data Analytics', label: 'Senior Expert - Risk & Data Analytics', group: 'Specialists',  permLevel: 'Specialist'   },
  // Development
  { value: 'Developer',                             label: 'Developer',                             group: 'Development',  permLevel: 'Developer'    },
  { value: 'Senior Developer',                      label: 'Senior Developer',                      group: 'Development',  permLevel: 'Developer'    },
  // Legacy
  { value: 'Specialist',                            label: 'Specialist (Legacy)',                   group: 'Specialists',  permLevel: 'Specialist'   },
];

const _LEVEL = Object.fromEntries(ALL_ROLES.map(r => [r.value, r.permLevel]));

/** Permission level for a role value. Mirrors backend roleHelper.getPermLevel. */
export const getPermLevel = (role) => _LEVEL[role] || 'Specialist';

/** Admin level: Administrator + Admin. Mirrors backend roleHelper.isAdmin. */
export const isAdminRole = (role) => ['SystemAdmin','Admin'].includes(getPermLevel(role));

/**
 * True when `role` satisfies any of `levels`.
 * Accepts permission levels ('Admin','Manager') and also raw role values, so
 * existing <SystemRoleGate roles={['Admin','Manager']}> call sites keep working.
 * SystemAdmin is the top tier and satisfies every gate.
 */
export const matchesLevels = (role, levels = []) => {
  if (!role || !levels.length) return false;
  if (getPermLevel(role) === 'SystemAdmin') return true;
  return levels.includes(getPermLevel(role)) || levels.includes(role);
};

export const ROLE_GROUPS = ['Admin', 'Executive', 'Management', 'Specialists', 'Development'];

export const ROLE_COLOR = {
  'Administrator':                        '#2E539F',
  'Admin':                                '#5C6BC0',
  'CEO':                                  '#7c3aed',
  'CPO':                                  '#5b21b6',
  'Chief Operating Officer':              '#6d28d9',
  'Co-Founder':                           '#8b5cf6',
  'Head of Product Delivery':             '#0891b2',
  'Manager':                              '#0891b2',
  'Implementation and Training Specialist': '#10b981',
  'Senior Implementation Specialist':     '#059669',
  'Specialist':                           '#10b981',
  'Communication Specialist':             '#16a34a',
  'Representative':                       '#22c55e',
  'Developer':                            '#2E539F',
  'Senior Developer':                     '#1d4ed8',
  'Senior Expert Risk and Data Analytics':'#d97706',
};

export const ALL_PAGES = [
  { path:'/',                   label:'Dashboard',           icon:'LayoutDashboard' },
  { path:'/projects',           label:'Projects',            icon:'FolderKanban'    },
  { path:'/tasks',              label:'Tasks',               icon:'CheckSquare'     },
  { path:'/activities',         label:'Activities',          icon:'Layers'          },
  { path:'/dev-hub',            label:'Dev Hub',             icon:'Bug'             },
  { path:'/clients',            label:'Clients',             icon:'Building2'       },
  { path:'/change-requests',    label:'Change Requests',     icon:'GitPullRequest'  },
  { path:'/training',           label:'Training',            icon:'GraduationCap'   },
  { path:'/workplan',           label:'Workplan',            icon:'CalendarDays'    },
  { path:'/milestones',         label:'Milestones',          icon:'Flag'            },
  { path:'/risks',              label:'Risk Register',       icon:'Shield'          },
  { path:'/milestone-timeline', label:'Timeline (Gantt)',    icon:'GanttChart'      },
  { path:'/kanban',             label:'Kanban Board',        icon:'Kanban'          },
  { path:'/reports',            label:'Reports',             icon:'BarChart3'       },
  { path:'/chat',               label:'Chat',                icon:'MessageSquare'   },
  { path:'/users',              label:'Users',               icon:'Users'           },
  { path:'/delegation',         label:'Delegation',          icon:'ArrowLeftRight'  },
  { path:'/notifications',      label:'Notifications',       icon:'Bell'            },
];
